import React from "react";
import { Link } from "react-router-dom";

import India from '../assets/india.png';
import Canada from '../assets/canada.png';
import UK from '../assets/united-kingdom.png';
import France from '../assets/france.png';
import Australia from '../assets/australia.png';
import USA from '../assets/usa.png'

const Footer = () => {
  const links = [
    { name: "Home", path: "/" },
    { name: "Contact", path: "/contact" },
    { name: "About Us", path: "/about" },
  ];
  
  const links1 = [
    "Android",
    "IOS",
    "PHP",
    "Asp.Net",
    "Graphics",
    "Digital Marketing",
    "AI",
    "IOT (Internet of Things)",
    "Big-Data Analytics",
    "Cloud Computing",
  ].map((name) => ({
    name,
    path: "/our-course", 
  }));
  return (
    <footer className="text-black  px-6 border-t-2  ">
       <Link to="/">
      <img
        src="/Megascale2.png"
        alt="Megascale"
        className="w-32 h-auto mb-4 hover:scale-110 md:ml-20 transition-transform duration-300"
      /></Link>
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 ">
        {/* Left Section - MegaScale Logo and Address */}
        <div>
          <h3 className="text-xl font-semibold mb-4 "> Address</h3>
          <div className="space-y-4">
          <div className="flex items-center">
              <img src={UK} alt="UK Flag" className="w-10 h-10 mr-3 hover:scale-105 transition-transform duration-300" />
              <p className="transition-colors font-semibold hover:text-blue-700">
              CV1 Coventry, West Midlands, United Kingdom
              </p>
            </div>
            <div className="flex items-center">
              <img src={India} alt="India Flag" className="w-10 h-10 mr-3 hover:scale-105 transition-transform duration-300" />
              <p className="transition-colors font-semibold hover:text-blue-700">
                411-412, New Escon Plaza, Chhaprabhatha Road, Chhaprabhatha, Amroli, Surat, Gujarat, India.
              </p>
            </div>
            <div className="flex items-center">
              <img src={Australia} alt="Australia Flag" className="w-10 h-10 mr-3 hover:scale-105 transition-transform duration-300" />
              <p className="transition-colors font-semibold hover:text-blue-700">
                17 Belford St Schofields NSW 2762, Australia.
              </p>
            </div>
            <div className="flex items-center">
              <img src={France} alt="France Flag" className="w-10 h-10 mr-3 hover:scale-105 transition-transform duration-300" />
              <p className="transition-colors font-semibold hover:text-blue-700">
                3 Rue Jean Jaurès Puteaux 92800, France.
              </p>
            </div>
            <div className="flex">
            <div className="flex items-center">
              <img src={Canada} alt="UK Flag" className="w-10 h-10 mr-3 hover:scale-105 transition-transform duration-300" />
              <p className=" font-semibold">Coming Soon</p>
            </div>
            <div className="flex items-center pl-5 ">
              <img src={USA} alt="UK Flag" className="w-10 h-10 mr-3 hover:scale-105 transition-transform duration-300" />
              <p className=" font-semibold">Coming Soon</p>
            </div></div>
          </div>

          {/* Contact Section */}
          <div className="pt-5">
            <h3 className="text-xl font-semibold mb-4 ">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-center">
                <span role="img" aria-label="email" className="mr-2">✉️</span>
                <p className="transition-colors font-semibold hover:text-blue-700">
                megascale.surat@gmail.com
                </p>
              </div>
              <div className="flex items-center">
                <span role="img" aria-label="phone" className="mr-2">📞</span>
                <p className="transition-colors font-semibold hover:text-blue-700">
                +91 88500 11652
                </p>
              </div>
            </div>
          </div>
        </div>


        {/* Middle Section - Company Info */}
        <div className="md:pl-28 ">
          <h3 className="text-xl font-semibold mb-4  ">Company</h3>
          <ul className="space-y-2">
            {links.map((link) => (
              <li key={link.name}>
                <Link
                  to={link.path}
                  className="hover:text-blue-700 font-semibold transition-colors"
                >
                  {link.name}
                </Link>
              </li> 
            ))}
          </ul>
        </div>


        {/* Right Section - Services */}
        <div>
          <h3 className="text-xl font-semibold mb-4 ">Courses</h3>
          <ul>
            {links1.map((link) => (
              <li key={link.name}>
                <Link
                  to={link.path}
                  className="hover:text-blue-700 font-semibold transition-colors"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>


      </div>

      {/* Footer Bottom Section */}
      <div className="text-center flex flex-row gap-4 font-semibold md:ml-10 my-4">
        <p className="text-base text-gray-500">&copy; 2025 by MegaScale. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
